var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    {
      staticClass: "universal-login",
      attrs: { "data-testid": "universal_login__message" },
    },
    [_vm._v(_vm._s(_vm.$t("label.redirecting")))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }